export default __webpack_public_path__ + "static/media/day_clear.dc2b5aa4.svg";